//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import { cloneDeep } from 'lodash';
import WorkingHours from 'src/components/WorkingHours';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    WorkingHours: WorkingHours
  },
  data: function data() {
    return {
      workingHours: undefined
    };
  },
  methods: {
    resetWorkingHours: function resetWorkingHours() {
      this.workingHours = this.me.account.settings.working_hours ? cloneDeep(this.me.account.settings.working_hours) : undefined;
    }
  },
  mounted: function mounted() {
    this.resetWorkingHours();
  }
};